import Modal from "bootstrap/js/dist/modal";
import { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import { isFunction } from "utils/helpers";
import { default as HcpShareDocumentForm } from "views/forms/HcpShareDocument";

const HcpShareDocument = ({ onSuccess, patientId, isShown, setShown }) => {
	const { t } = useTranslation();

	// portal dom element
	let portalsRoot = document.getElementById("portals") || null;
	if (!portalsRoot) {
		portalsRoot = document.createElement("div");
		portalsRoot.setAttribute("id", "portals");
		document.body.appendChild(portalsRoot);
	}

	// ref hook
	const modalRef = useRef(null);

	// effect hook
	useEffect(() => {
		const modalCurrentElement = modalRef?.current;
		let modal = Modal.getInstance(modalCurrentElement);
		if (!modal) {
			modal = new Modal(modalCurrentElement)[isShown ? "show" : "hide"]();
			modalCurrentElement?.addEventListener("hidden.bs.modal", () => isFunction(setShown) && setShown(false));
		} else {
			if (isShown) modal.show();
			if (!isShown) modal.hide();
		}
		return () => (modal ? Modal.getInstance(modalCurrentElement).dispose() : false);
	}, [isShown, setShown]);

	return (
		portalsRoot &&
		ReactDOM.createPortal(
			<div
				className="modal fade"
				ref={modalRef}
				tabIndex="-1"
				id="hcpShareDocumentModal"
				aria-labelledby="hcpShareDocumentModalTitle"
				aria-hidden="true">
				<div className="modal-dialog modal-dialog-centered">
					<div className="modal-content bg-white border-0">
						<div className="modal-header border-0">
							<h5 className="modal-title text-uppercase" id="hcpShareDocumentModalTitle">
								<span className="d-flex gap-2 align-items-center">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="17.632"
										height="17.644"
										fill="currentColor"
										className="flex-shrink-0 text-primary"
										viewBox="0 0 17.632 17.644">
										<g transform="translate(-0.176)">
											<path d="M9.515,4.183A9.863,9.863,0,0,0,.176,13.991v3.653L1.483,14.6A9.517,9.517,0,0,1,9.515,9.352v4.181l8.293-6.779L9.515,0Z" />
										</g>
									</svg>
									<small className="flex-grow-1">
										<strong>upload document</strong>
									</small>
								</span>
							</h5>
							<button
								type="button"
								className="btn-close ms-auto"
								data-bs-dismiss="modal"
								aria-label={t("actions.close")}></button>
						</div>
						<div className="modal-body customized-scroll pt-0">
							<HcpShareDocumentForm
								patientId={patientId}
								onSuccessCb={(uploadedDocuments) =>
									isFunction(onSuccess) &&
									onSuccess((cb) => {
										modalRef?.current?.addEventListener(
											"hide.bs.modal",
											async () => isFunction(cb) && cb(),
											{ once: true }
										);
										Modal.getInstance(modalRef?.current).hide();
									}, uploadedDocuments)
								}
							/>
						</div>
					</div>
				</div>
			</div>,
			portalsRoot
		)
	);
};

export default HcpShareDocument;
